import { Box, Choicebox, FormGroup } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { IOrthOV1ProcedureExaminationsProps } from './OrthOV1ProcedureExaminations';
import { OrthOExaminationOrder } from './orthOExaminationOrder';
import { ReadOrEditInputField } from './ReadOrEditInputField';

const extraBinoculaireExaminations = ['15^ prismatest', 'Omgekeerde prismatest', 'Four Dot-test'];

type IOrthOExtraBinoculaireExaminations = (typeof extraBinoculaireExaminations)[number];

export function OrthOV1ProcedureSelectedExtraBinocularExaminations(props: IOrthOV1ProcedureExaminationsProps) {
    const [selectedExtraBinoculaireExaminations, setSelectedExtraBinoculaireExaminations] = useState<
        IOrthOExtraBinoculaireExaminations[]
    >([]);

    useEffect(() => {
        const extraBinoculaireExaminationsToSet = [...selectedExtraBinoculaireExaminations];
        if (props.customControlData.prismatest_15 && !selectedExtraBinoculaireExaminations.includes('15^ prismatest')) {
            extraBinoculaireExaminationsToSet.push('15^ prismatest');
        }
        if (
            props.customControlData.prismatest_omgekeerde &&
            !selectedExtraBinoculaireExaminations.includes('Omgekeerde prismatest')
        ) {
            extraBinoculaireExaminationsToSet.push('Omgekeerde prismatest');
        }
        if (props.customControlData.four_dot_test && !selectedExtraBinoculaireExaminations.includes('Four Dot-test')) {
            extraBinoculaireExaminationsToSet.push('Four Dot-test');
        }
        setSelectedExtraBinoculaireExaminations(extraBinoculaireExaminationsToSet);
    }, []);

    return (
        <>
            {!props.isReadOnly && (
                <FormGroup label="Onderzoek toevoegen">
                    <Box
                        display="flex"
                        flexDirection="row"
                        flexWrap="wrap"
                        gap={3}
                    >
                        {extraBinoculaireExaminations.map((examination, index) => {
                            return (
                                <Choicebox
                                    checked={selectedExtraBinoculaireExaminations.includes(examination)}
                                    key={`${examination}-${index}`}
                                    label={examination}
                                    name={examination}
                                    onChange={() => addOrRemoveExamination(examination)}
                                    tabIndex={OrthOExaminationOrder.binocularExamination}
                                />
                            );
                        })}
                    </Box>
                </FormGroup>
            )}

            {selectedExtraBinoculaireExaminations.includes('15^ prismatest') && (
                <ReadOrEditInputField
                    {...props}
                    error={props.errors?.get('customControlData.prismatest_15')}
                    fieldKey="prismatest_15"
                    hasErrors={props.errors?.has('customControlData.prismatest_15')}
                    isRequired={false}
                    label="orthOProcedure.prismatest_15"
                    placeholder="Bevindingen..."
                    tabIndex={OrthOExaminationOrder.binocularExamination}
                    value={props.customControlData.prismatest_15}
                />
            )}

            {selectedExtraBinoculaireExaminations.includes('Omgekeerde prismatest') && (
                <ReadOrEditInputField
                    {...props}
                    error={props.errors?.get('customControlData.prismatest_omgekeerde')}
                    fieldKey="prismatest_omgekeerde"
                    hasErrors={props.errors?.has('customControlData.prismatest_omgekeerde')}
                    isRequired={false}
                    label="orthOProcedure.reverse_prismatest"
                    placeholder="Bevindingen..."
                    tabIndex={OrthOExaminationOrder.binocularExamination}
                    value={props.customControlData.prismatest_omgekeerde}
                />
            )}

            {selectedExtraBinoculaireExaminations.includes('Four Dot-test') && (
                <ReadOrEditInputField
                    {...props}
                    error={props.errors?.get('customControlData.four_dot_test')}
                    fieldKey="four_dot_test"
                    hasErrors={props.errors?.has('customControlData.four_dot_test')}
                    isRequired={false}
                    label="orthOProcedure.four_dot_test"
                    placeholder="Bevindingen..."
                    tabIndex={OrthOExaminationOrder.binocularExamination}
                    value={props.customControlData.four_dot_test}
                />
            )}
        </>
    );

    function addOrRemoveExamination(examination: IOrthOExtraBinoculaireExaminations) {
        if (!props.isReadOnly) {
            if (selectedExtraBinoculaireExaminations.includes(examination)) {
                props.handleChangeCustomControl({ [examination]: null });
                setSelectedExtraBinoculaireExaminations([
                    ...selectedExtraBinoculaireExaminations.filter((selectedExam) => selectedExam !== examination),
                ]);
            } else {
                setSelectedExtraBinoculaireExaminations([...selectedExtraBinoculaireExaminations, examination]);
            }
        }
    }
}
